import type { z } from 'zod';
import type { DeepUndefinedOrNull } from '@/types/partial';
import { ProdutoAdicionalSchema } from '@/features/produto-adicional/types/ProdutoAdicional';
import {
    type ProdutoAdicionalItemBody,
    ProdutoAdicionalItemSchema,
} from '@/features/produto-adicional/types/ProdutoAdicionalItem';

const ProdutoProdutoAdicionalItemSchema = ProdutoAdicionalItemSchema.omit({
    pai_empresa_idpk: true,
    pai_produto_adicional_idpk: true,
    pai_produto_idpk: true,
});

// Para evitar colisão de nome entre o outro ProdutoAdicional
export const ProdutoProdutoAdicionalSchema = ProdutoAdicionalSchema.omit({
    pra_empresa_idpk: true,
}).extend({
    item: ProdutoProdutoAdicionalItemSchema.array().nullable(),
});

export type ProdutoProdutoAdicional = z.infer<typeof ProdutoProdutoAdicionalSchema>;

export type ProdutoProdutoAdicionalBody = Omit<
    DeepUndefinedOrNull<ProdutoProdutoAdicional>,
    'item'
> & {
    alterar: boolean;
    key: string;
    item?: ProdutoAdicionalItemBody[] | null;
    excluir?: 'S';
};
